import { Box } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import { TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const InputTab = ({ options = [], selectedTab, handleChange }) => {
  return (
    <Box className={styles['input-tab__container']}>
      <Iteration
        items={options}
        render={(opt) => {
          const isActive = opt?.value === selectedTab?.value;

          return (
            <Box
              key={opt.value}
              onClick={() => handleChange(opt)}
              className={`${isActive ? styles['input-tab__button--active'] : styles['input-tab__button--inactive']} ${styles['input-tab__button']}`}
            >
              <TextSemiBold className={styles['input-tab__button-text']}>{opt?.label}</TextSemiBold>
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default InputTab;
